import React, { FC } from 'react'
import InfoRepContainer from 'containers/Rep/Info'

const RepPage: FC = () => <InfoRepContainer />

export default RepPage
